export enum MatchCategory {
  ADS = 'ADS',
  LIVE_MENTIONS = 'LIVE_MENTIONS',
  AD_OVERLAY = 'AD_OVERLAY',
}
